export default __webpack_public_path__ + "static/media/aid.b00ef52a.svg";